import React, { useCallback } from 'react';
import NumberFormat from 'react-number-format';
// import debounce from 'lodash.debounce';
import { Input, Div } from '@pinpoint/design-kit';

const defaultNumericFormat = {
	thousandSeparator: true,
	decimalSeparator: '.',
	thousandsGroupStyle: 'thousand',
	fixedDecimalScale: true,
	allowNegative: false,
	allowLeadingZeros: false,
	decimalScale: 0,
};

const cellFormatMap = {
	numeric: defaultNumericFormat,
	currency: {
		...defaultNumericFormat,
		decimalScale: 0,
		prefix: '$',
	},
	percentage: {
		...defaultNumericFormat,
		decimalScale: 1,
		fixedDecimalScale: false,
		suffix: '%',
	},
};

function InputCell({
	format,
	formattingOptions,
	inputValue,
	DivProps,
	InputProps,
	inputRefs,
	idx,
	inputPath,
	onChange,
	disableInput,
}) {
	const mergedFormat = {
		...cellFormatMap[format],
		...formattingOptions,
	};
	// const handleChange = useMemo(() => debounce(onChange, 1000), []);
	// console.log(inputPath, disableInput);
	const changeHandler = useCallback(
		({ value: nextValue }) => {
			onChange(inputPath, +nextValue);
		},
		[inputPath, disableInput, onChange]
	);
	return (
		<Div m="0.5px" minH="20px" rounded="sm" d="flex" justify="end" align="center" {...DivProps}>
			<NumberFormat
				// disabled={disableInput}
				getInputRef={(ref) => {
					// NOTE: references to inputRefs are implicitly using ref.current (passed in via parent)
					// eslint-disable-next-line no-param-reassign
					inputRefs[idx] = ref;
				}}
				customInput={Input}
				value={inputValue}
				onValueChange={changeHandler}
				displayType="input"
				allowNegative
				h="1rem"
				rounded="0"
				maxW="8rem"
				p={{ x: '0.5rem', y: '1px' }}
				borderColor="shadeCC"
				focusBorderColor="blue"
				focusBorder="2px solid"
				border="1px solid"
				style={{
					caretColor: InputProps.textColor,
					fontFamily: 'Inter',
				}}
				onKeyDown={(evt) => {
					const { keyCode } = evt;
					const prevRef = idx === 0 ? null : inputRefs[idx - 1];
					const nextRef = idx === inputRefs.length - 1 ? null : inputRefs[idx + 1];
					// NOTE: 13 = 'Enter', 38 = 'ArrowUp', 40 = 'ArrowDown'
					if (nextRef && [13, 40].includes(keyCode)) nextRef.focus();
					if (prevRef && keyCode === 38) prevRef.focus();
				}}
				{...mergedFormat}
				{...InputProps}
			/>
		</Div>
	);
}

export default InputCell;
